import React from 'react'
import { useIntl, Link } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'
import ITBBookingAppointment from '../../components/PressRelease/ITBBookingAppointment'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/Nezasa_1_1_en.jpg'
import ImageDE from '../../images/news/Nezasa_1_1_de.jpg'

import { newsList } from '../../components/NewsPage/data'

/* eslint-disable max-len */
const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNezasa)}
        imageAlt={formatMessage(messages.TitleNezasa)}
        description={formatMessage(metaDescription.NewsNezasaDescription)}
        image={locale === 'de' ? ImageDE : Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.nezasa}
        articleLinks={{
          tsbo: (
            <Link to="/products/quickstart/">
              TravelSandbox®
            </Link>
          ),
          ta: (
            <a href='https://www.touristik-aktuell.de/nachrichten/reisevertrieb/news/datum/2025/02/18/dynamic-packaging-nezasa-nutzt-freshcells-daten/' target="_blank" rel="noopener noreferrer">https://www.touristik-aktuell.de/nachrichten/reisevertrieb/news/datum/2025/02/18/dynamic-packaging-nezasa-nutzt-freshcells-daten/</a>
          ),
          at: (
            <a href='https://abouttravel.ch/reisebranche/freshcells-und-nezasa-praesentieren-reiseplattform/' target="_blank" rel="noopener noreferrer">https://abouttravel.ch/reisebranche/freshcells-und-nezasa-praesentieren-reiseplattform/</a>
          ),
          fvw: (
            <a href='https://www.fvw.de/touristik/technologie/individuelle-reisepakete-freshcells-und-nezasa-starten-flexible-reiseplattform-250170' target="_blank" rel="noopener noreferrer">https://www.fvw.de/touristik/technologie/individuelle-reisepakete-freshcells-und-nezasa-starten-flexible-reiseplattform-250170</a>
          )
        }}
        addon={<ITBBookingAppointment />}
      />
    </Layout>
  )
}

export default IndexPage
